import React, { Component } from "react";
import reactCSS from "reactcss";

import { colors } from "assets";

class PageTitle extends Component {
  render() {
    const styles = reactCSS(
      {
        default: {
          title: {
            marginBottom: 20,
            fontWeight: 900,
            fontFamily: "Roboto",
            fontSize: "36px",
            color: "#222"
          }
        },
        primary: {
          title: {
            color: colors.primary.dark
          }
        },
        secondary: {
          title: {
            color: colors.secondary.dark
          }
        },
        accent: {
          title: {
            color: colors.accent.dark
          }
        }
      },
      this.props,
      this.state
    );

    return (
      <div className="page-title" style={styles.title}>
        {this.props.children}
      </div>
    );
  }
}

export default PageTitle;



// WEBPACK FOOTER //
// ./src/components/support/page/page-title.js